// import Vuex from "vuex";
import auth from './auth.module'
import campaign from './campaign.module'
import change from './change.module'
import content from './content.module'
import feed from './feed.module'
import task from './task.module'
import workspace from './workspace.module'
import workspaceMember from './workspaceMember.module'
import workspaceSettings from './workspaceSettings.module'
import topic from './topic.module'
import tag from './tag.module'
import campaignTagModule from './campaignTag.module'
import HashTagsModule from './hashTags.module'
import activity from './activity.module'
import post from './post.module'
import roles from './roles.module'
import reward from './reward.module'
import changelog from './changelog.module'
import auditLog from './auditlog.module'
import image from './image.module'
import blacklist from './blacklist.module'
import guest from './guest.module'
import coupon from './coupon.module'
import invoice from './invoice.module'
import subscription from './subscription.module'
import signup from './signup.module'
import share from './share.module'
import settings from './settings.module'
import leaderboard from './leaderboard.module'
import common from './common.module'
import schedule from './schedule.module'
import cloudinary from './cloudinary.module'
import comments from './comments.module'
import stats from './stats.module'
import clearbit from './clearbit.module'
import store from './store.module'
import networkConnections from './networkConnections.module'
import networkConnectionTypes from './networkConnectionTypes.module'
import audit from './audit.module'
import timezone from './timezone.module'
import reportKeyword from './reportKeyword.module'
import metadata from './metadata.module'
import notification from './notification.module'
import report from './report.module'
import chatgpt from './chatgpt.module'
import tagGroupModule from './tagGroup.module'
import profileModule from './profile.module'
import toneOfVoiceModule from './toneOfVoice.module'
import promptTopicModule from './promptTopic.module'
import enrich from './enrich.module'
import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'

// Might be some persisted-state options we need to set.
// Reference: https://www.npmjs.com/package/vuex-persisted state

// We should also be updating things like content and tasks via service workers, and caching many API requests via the Cache API.
// Maybe the server can return flags to say whether cache data should be invalidated. That would be easy to do if we maintain some
// kind of last_modified table.
// Reference: https://web.dev/cache-api-quick-guide/

// generated modules
import feedGen from './modules/feed'
import customization from './customization.module'

const vuexPersistence = new VuexPersistence({
    storage: window.localStorage,

    reducer: (state) => {
    	return ({
			auth: {
				roles: state.auth.roles,
				disabledRoles: state.auth.disabledRoles,
				auth: state.auth.auth,
				workspace: state.auth.workspace,
				error_code: state.auth.error_code,
				error_message: state.auth.error_message,
				originalUsername: state.auth.originalUsername,
				originalAuth: state.auth.originalAuth,
				originalWorkspace: state.auth.originalWorkswpace,
				authedMemberInfo: state.auth.authedMemberInfo,
				selectedVersions: state.auth.selectedVersions,
				// don't include token here
			},
			networkConnections: {persistedSelectedNetworkConnectionId: state.persistedSelectedNetworkConnectionId},
			customization: {
				showFixMeBanner: state.customization.showFixMeBanner,
			},
		}
	)},
})

export default createStore({
    state() {
        return {
            routing: false,
            appMessage: {
                error: {
                    key: 0,
                    message: '',
                }
            }
        }
    },
    getters: {
    	isRouting: state => state.routing,
    },
    mutations: {
        updateRouting(state, condition) {
            state.routing = condition
        },
        setAppMessageError(state, nessage) {
            ++state.appMessage.error.key
            state.appMessage.error.message = nessage
        },
    },
    modules: {
        feedGen,
        auth,
        campaign,
        change,
        content,
        feed,
        tag,
        task,
        workspace,
        workspaceMember,
        workspaceSettings,
        topic,
        campaignTagModule,
        HashTagsModule,
        activity,
        post,
        reward,
        changelog,
        auditLog,
        image,
        blacklist,
        guest,
        coupon,
        invoice,
        roles,
        subscription,
        signup,
        share,
        settings,
        leaderboard,
        common,
        schedule,
        cloudinary,
        comments,
        clearbit,
        stats,
        store,
        reportKeyword,
        networkConnections,
        networkConnectionTypes,
        audit,
        timezone,
        metadata,
        notification,
        report,
        tagGroupModule,
        profileModule,
        chatgpt,
        toneOfVoiceModule,
        promptTopicModule,
        customization,
        enrich,
    },
    plugins: [vuexPersistence.plugin],
})
